import { Component, HostListener } from '@angular/core';

@Component({
    selector: '.ripple',
    styles: [`
      :host {
        display: inline-block;
        position: relative;
        overflow: hidden;
        -webkit-user-select: none; 
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: pointer;
      }

      
      @-webkit-keyframes ripple {
          to {
            -webkit-transform: scale(2);
            opacity: 0;
          }
      }

      @keyframes ripple {
          to {
            transform: scale(2);
            opacity: 0;
          }
      }

      :host /deep/ .ripple-effect {
        -webkit-animation: ripple 800ms ease-out;
        animation: ripple 800ms ease-out;
        background-color: rgba(0, 0, 0, 0.24);
        border-radius: 100%;
        height: 10px;
        pointer-events: none;
        position: absolute;
        transform: scale(0);
        width: 10px;
      }

      :host /deep/ .ripple-light .ripple-effect {
        background-color: rgba(255, 255, 255, 0.32);
      }

      :host /deep/ .ripple-dark .ripple-effect {
        background-color: rgba(255, 255, 255, 1);
      }

  `],
    template: '<ng-content></ng-content>',
})
export class RippleComponent {
    @HostListener('click', ['$event', '$event.currentTarget'])
    click(event, element) {
        var ripple = document.createElement('span'),
            rect = element.getBoundingClientRect(),
            radius = Math.max(rect.height, rect.width),
            left = event.pageX - rect.left - radius / 2 - document.body.scrollLeft,
            top = event.pageY - rect.top - radius / 2 - document.body.scrollTop;

        ripple.className = 'ripple-effect animate';
        ripple.style.width = ripple.style.height = radius + 'px';
        ripple.style.left = left + 'px';
        ripple.style.top = top + 'px';
        ripple.addEventListener('animationend', () => {
            element.removeChild(ripple);
        });

        element.appendChild(ripple);
    }
}


// WEBPACK FOOTER //
// ./app/common/ripple.component.ts